import { useCallback } from 'react';
import { useLazyQuery } from 'src/graphql';
import { USER_QUERY } from 'src/graphql/user/query';
import client from 'src/utils/api/client';

export default (skip = false) => {
  const [getUser] = useLazyQuery(USER_QUERY, { skip });

  return useCallback(
    (userId = null) => {
      const variables = userId ? { id: userId } : {};
      return client.query({query: USER_QUERY, variables, fetchPolicy:'network-only'});
    },
    [],
  );
};
